<div id="openai_chat_model" class="chat_mk_bg chat_hide">
  <!-- <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true">
    <p style="color: white"> Generating Response... </p>
  </ngx-spinner> -->
  <button class="chat_close_icon" mat-icon-button (click)="closeChatModel()">
    <mat-icon>cancel</mat-icon>
  </button>
  <div class="show_sidebar_button" title="Sidebar Show" (click)="showSidePanel()">
    <mat-icon>double_arrow</mat-icon>
  </div>
  <div id="chat_side_panel" class="chat_side_bar_panel chat_side_bar_panel_show">
    <div class="chat_sidebar_top">
      <div class="new_chat_button" (click)="startNewChat()">
        <mat-icon>add</mat-icon>
        <h3>New Chat</h3>
      </div>
      <div class="close_sidebar_button" title="Sidebar Close" (click)="closeSidePanel()">
        <mat-icon>keyboard_double_arrow_left</mat-icon>
      </div>
    </div>
    <div class="chat_sidebar_content">
      <div class="sidebar_content" *ngFor="let search of savedSearches; ">
        <h3 class="group_text" *ngIf="search?.data?.length > 0">{{search?.groupText}}</h3>
        <app-saved-chat [data]="search?.data" [selectedChatId]="selectedChatId" (onClickChat)="onClickChat($event)">
        </app-saved-chat>
      </div>
    </div>
    <div class="chat_sidebar_bottom">
      <div class="chat_profile_img_wrapper">
        <!-- <img src="https://o3storage.blob.core.windows.net/o3-live-attachments/ProfileImage/100003_2022-11-27_20221127T144255438.jpg" alt="profile_pic"> -->
        <ngx-avatar size="50" [src]="userProfile?.picture ? userProfile?.picture : ''" [name]="userProfile?.fullName"
        [textSizeRatio]="2" [round]="true" [initialsSize]="2"></ngx-avatar>
      </div>
      <div class="chat_profile_user">
        <p>{{'okaccr' | titlecase}}</p>
      </div>
    </div>
  </div>
  <div id="chat_main" class="chat_main_content chat_main_content_width">
    <app-new-chat *ngIf="isNewChat && selectedChatId === 0"></app-new-chat>
    <div id="scroll_area_container" style="overflow-y: auto; height: 100%;" *ngIf="!isNewChat && selectedChatId > 0">
      <app-save-chat-content [data]="selectedChatData" [isNewSearch]="isNewSearch" [newSearchData]="newSearchData">
      </app-save-chat-content>
    </div>
    <div id="scroll_button" class="scroll_to_end_button_wrapper">
      <mat-icon>arrow_circle_down</mat-icon>
    </div>
    <div class="openai_chat_search">
      <div>
        <button class="stop-respone-button" (click)="stopGeneratingResponse()" *ngIf="isRequestInProgress"
          mat-raised-button color="warn">Stop Generating Response</button>
      </div>
      <div class="search_wrapper">
        <div class="search_area_wrapper">
          <textarea placeholder="Send a message" rows="1" id="chat_search_textarea" [formControl]="searchCtrl"
            (keyup.enter)="searchNewQuery()">
              </textarea>
        </div>
        <img src="../../../assets/images/aggrid-spinner.gif" width="30px" height="30px" alt="...loading"
          *ngIf="isRequestInProgress">
        <button class="chat-send-button" mat-icon-button (click)="searchNewQuery()" *ngIf="!isRequestInProgress">
          <mat-icon id="chat_search_icon" style="color: darkcyan;">send</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>